"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _MarginCryptoDepositFormComponent = _interopRequireDefault(require("./MarginCryptoDepositFormComponent"));
var _depositActions = require("../../../../../redux/actions/depositActions");
var _snackbarActions = require("../../../../../redux/actions/snackbarActions");
var _depositWithdrawalSelectors = require("../../../../../redux/selectors/depositWithdrawalSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedAddress: (0, _depositWithdrawalSelectors.depositAddressSelector)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectDepositProduct: function selectDepositProduct(productId) {
      return dispatch((0, _depositActions.fetchProductDepositTemplate)(productId));
    },
    showSnack: function showSnack(text) {
      return dispatch((0, _snackbarActions.showSnack)(text));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_MarginCryptoDepositFormComponent["default"]);